<template>
  <div class="step">
    <h2>I Programmi Sace</h2>
    <p class="subtitle text-medium">
      Puoi iscriverti ai programmi anche in un secondo momento
    </p>
    <div class="fieldset">
      <div v-if="showEdu" class="input-wrapper x2">
        <div class="checkbox-field">
          <input
            id="saceEducation"
            v-model="saceEducation.saceEduSigned"
            type="checkbox"
            tabindex="1"
          >
          <label
            for="saceEducation"
            class="text-medium"
          >
            <strong>Voglio iscrivermi a SACE Education</strong>
          </label>
        </div>
        <p class="text-medium">
          Iscriviti all'hub formativo di SACE per ricevere gratuitamente in anteprima novità e
          approfondimenti sulle attività formative dedicate a te e alla tua impresa.
        </p>
        <fragment v-if="saceEducation.saceEduSigned && !preRegistration">
          <div class="input-wrapper">
            <div
              v-for="(element, i) in interestsList"
              :key="i"
              class="checkbox-field"
            >
              <input
                :id="element.id"
                v-model="saceEducation.options"
                type="checkbox"
                :name="element.key"
                :value="element.value"
                :checked="element.checked"
              >
              <label
                :for="element.id"
                class="text-medium"
              >
                {{ element.label }}
              </label>
            </div>
            <div class="checkbox-field">
              <input
                id="allInterests"
                v-model="allInterests"
                type="checkbox"
                :checked="allInterests"
              >
              <label
                for="allInterests"
                class="text-medium"
              >
                Tutte
              </label>
            </div>
          </div>
          <p class="text-small">
            Ti informiamo che SACE, al fine di poterti offrire contenuti ed eventi di tuo interesse,
            effettuerà un'attività di profilazione in conformità a quanto previsto dalla vigente
            normativa in materia di protezione dei dati personali. Segnalando e selezionando le aree
            tematiche più importanti per te (qui di seguito riportate) autorizzi SACE a procedere
            all'effettuazione della suddetta attività.
          </p>
        </fragment>
        <p class="text-small">
          Registrandomi dichiaro di aver preso visione dell'<a
            href="/resources/docs/informativa-privacy-programma-sace-education-business-matching.pdf"
            target="_blank"
          >informativa privacy</a>
          fornita ai sensi dell'art. 13 del GDPR e presto il consenso al trattamento dei miei dati
          personali al fine di ricevere in anteprima le comunicazioni in merito all'offerta
          formativa relativa al Programma SACE Education.
        </p>
      </div>
      <div
        v-if="showBP"
        class="input-wrapper"
      >
        <div class="checkbox-field">
          <input
            id="businessPromotion"
            v-model="businessPromotion"
            type="checkbox"
            tabindex="2"
          >
          <label
            for="businessPromotion"
            class="text-medium"
          >
            <strong>
              Iscriviti al programma di business matching "Sace Connects"
            </strong>
          </label>
        </div>
        <p class="text-medium">
          Sace Connects è il programma di Sace dedicato al business matching fra aziende
          italiane, in particolare PMI, e Buyer stranieri operanti in paesei ad alto potenziale per
          l'export italiano.
        </p>
        <p class="text-small">
          Registrandomi dichiaro di aver preso visione dell'<a
            href="/resources/docs/informativa-privacy-programma-sace-education-business-matching.pdf"
            target="_blank"
          >informativa privacy</a>
          fornita ai sensi dell'art. 13 del GDPR e presto il consenso al trattamento dei miei dati
          personali al fine di ricevere le comunicazioni inerenti le opportunità di business
          matching.
        </p>
      </div>
    </div>
    <div class="actions">
      <button
        class="button primary"
        @click="!disabled ? navigate('next') : null"
      >
        Avanti
      </button>
      <button
        class="back"
        @click="navigate('prev')"
      >
        Torna indietro
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from 'vue-lodash';
import Fragment from 'vue-fragment';
import lodash from 'lodash';
import { Paths } from '../../common/paths';
import { GestioneProfili } from '../../common/utenze';

Vue.use(VueLodash, { lodash });
Vue.use(Fragment.Plugin);

const _ = require('lodash');

export default {
  name: 'Programmi',
  components: {},
  props: {
    preset: {
      type: Object,
      default: () => {},
    },
    michelangeloCode: {
      type: Number,
      default: NaN,
    },
    company: {
      type: Object,
      required: true,
    },
    profileId: {
      type: String,
      required: true,
    },
    preRegistration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saceEducation: {
        saceEduSigned: false,
        options: [],
      },
      businessPromotion: false,
      allInterests: false,
      interestsList: [],
    };
  },
  computed: {
    showEdu() {
      return GestioneProfili.ProfiliEdu.includes(this.profileId);
    },
    showBP() {
      if (GestioneProfili.Ibridi.includes(this.profileId)) {
        return this.michelangeloCode != NaN && this.michelangeloCode != null;
      }
      return GestioneProfili.ProfiliBp.includes(this.profileId);
    },
    isDipAziendaEstera() {
      return this.profileId == GestioneProfili.Profili.DIP_AZIENDA_ESTERO;
    },
    allCehcked() {
      return this.saceEducation.options.length === this.interestsList.length;
    },
  },
  watch: {
    preset: {
      handler(v) {
        if (!_.isEmpty(v)) {
          this.businessPromotion = v.businessPromotion;
          this.saceEducation.saceEduSigned = v.saceEducation.saceEduSigned;
          if (v.saceEducation.saceEduSigned) {
          }
          this.saceEducation.options = [];
        }
      },
      deep: true,
      immediate: true,
    },
    allCehcked(value) {
      if (value) {
        this.allInterests = true;
      } else {
        this.allInterests = false;
      }
    },
    allInterests(value) {
      if (value && !this.allCehcked) {
        this.saceEducation.options = [];
        for (let index = 0; index < this.interestsList.length; index += 1) {
          const element = this.interestsList[index];
          this.saceEducation.options.push(element.value);
        }
      } else if (!value && this.allCehcked) {
        this.saceEducation.options = [];
      }
    },
  },
  mounted() {
    if (!this.preRegistration) {
      this.loadOptions();
    }
    this.$emit('push-event');
  },
  methods: {
    loadOptions() {
      this.$root.showLoading(true);
      this.$http
        .get(Paths.saceEducation.registration.options)
        .then(response => {
          const { values } = response.data;
          this.interestsList = values.map(el => {
            let label = null;
            let key = null;
            let checked = false;
            switch (el.Name) {
            case 'education-to-export':
              label = 'Export e internazionalizzazione';
              key = 'exportAndInternationalization';
              break;
            case 'sace-academy':
              label = 'Corsi certificati e accademici';
              key = 'certifiedAndAcademicCourses';
              break;
            case 'infrastructure-green-digital':
              label = 'Transizione ecologica e digitale';
              key = 'ecologicalAndDigitalTransition';
              break;
            case 'corsi-e2e':
              label = 'Eventi';
              key = 'events';
              break;
            default:
              break;
            }
            const value = { id: el.Id, label, key };
            const presetSaceEducation = this.preset.saceEducation;
            if (!_.isEmpty(presetSaceEducation)) {
              for (const key in presetSaceEducation) {
                if (Object.hasOwnProperty.call(presetSaceEducation, key)) {
                  const element = presetSaceEducation[key];
                  if (element.id === el.Id) {
                    checked = true;
                    this.saceEducation.options.push(value);
                  }
                }
              }
            }
            return {
              id: el.UrlName,
              title: el.Title,
              label,
              value,
              checked,
            };
          });
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.$root.showLoading(false);
        });
    },
    navigate(step) {
      if (!this.showBP) {
        this.businessPromotion = false;
      }
      // if (GestioneProfili.NoEdu.includes(this.profileId)) {
      //   this.saceEducation.saceEduSigned = false;
      // }
      const { saceEduSigned, options } = this.saceEducation;
      const obj = {
        params: {
          saceEducation: {
            saceEduSigned,
          },
          businessPromotion: this.businessPromotion,
        },
        step: 'programs',
        navigate: step,
      };
      for (const el of options) {
        const { key, id, label } = el;
        obj.params.saceEducation[key] = { id, label };
      }
      this.$emit('navigate', obj);
    },
  },
};
</script>
